import React from "react"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const MySwal = withReactContent(Swal)

const CONTACT_EMAIL = "technique@adtractive-group.fr"

const FEATURES = [
  {
    icon: "fas fa-users",
    title: "Ciblage démographique",
    description: "Adaptez vos publicités selon l'âge et le genre de l'audience détectée.",
  },
  {
    icon: "fas fa-chart-line",
    title: "Diffusion intelligente",
    description: "Le système sélectionne la publicité la plus pertinente en temps réel.",
  },
  {
    icon: "fas fa-bullseye",
    title: "Meilleur impact",
    description: "Augmentez l'efficacité de vos campagnes grâce au ciblage contextuel.",
  },
]

export function AiTargetingAccessDialogContent() {
  return (
    <div className="ai-access-dialog">
      <div className="ai-access-dialog__icon-wrapper">
        <div className="ai-access-dialog__icon">
          <i className="fas fa-crosshairs"></i>
        </div>
      </div>

      <p className="ai-access-dialog__intro">
        Le <strong>Ciblage IA</strong> est un module intelligent qui optimise automatiquement
        la diffusion de vos publicités en fonction du contexte.
      </p>

      <div className="ai-access-dialog__features">
        {FEATURES.map((feature) => (
          <div key={feature.title} className="ai-access-dialog__feature">
            <div className="ai-access-dialog__feature-icon">
              <i className={feature.icon}></i>
            </div>
            <div>
              <div className="ai-access-dialog__feature-title">{feature.title}</div>
              <div className="ai-access-dialog__feature-desc">{feature.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="ai-access-dialog__contact">
        <div className="ai-access-dialog__contact-label">
          <i className="fas fa-envelope"></i>
          Pour activer cette fonctionnalité, contactez-nous :
        </div>
        <a href={`mailto:${CONTACT_EMAIL}`} className="ai-access-dialog__contact-email">
          {CONTACT_EMAIL}
        </a>
      </div>
    </div>
  )
}

export const openAiTargetingAccessDialog = () => {
  return MySwal.fire({
    html: <AiTargetingAccessDialogContent />,
    showConfirmButton: true,
    confirmButtonText: "Fermer",
    confirmButtonColor: "#133D94",
    showCloseButton: true,
    width: "520px",
    customClass: {
      popup: "ai-access-dialog__popup",
    },
  })
}
